import { render } from "./MaterialLibrary.vue?vue&type=template&id=9af5e05c&scoped=true"
import script from "./MaterialLibrary.vue?vue&type=script&lang=js"
export * from "./MaterialLibrary.vue?vue&type=script&lang=js"

import "./MaterialLibrary.vue?vue&type=style&index=0&id=9af5e05c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9af5e05c"]])

export default __exports__